import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface DeviceDetailsById {
  deviceTemplateId: string
  deviceType: string
  commTypeId: string
  commType: string
  dataTypeId: string
  datatypeName: string
  fileName: string
  uploadStatus: string
  registers: any
}
export interface DeviceDetailsByIdState {
  isLoading: boolean
  loadingError: string | null
  customDeviceListByID: DeviceDetailsById | null
  httpStatus: number | null
}
const initialState: DeviceDetailsByIdState = {
  isLoading: true,
  loadingError: null,
  customDeviceListByID: null,
  httpStatus: null
}

const customDeviceByIdSlice = createSlice({
  name: 'customDeviceByIdListSlice',
  initialState,
  reducers: {
    customDeviceByIdLoadingAction: (state) => {
      return {
        isLoading: true,
        loadingError: null,
        customDeviceListByID: null,
        httpStatus: 0
      }
    },
    customDeviceByIdUpdateAction: (state, action: PayloadAction<{ data: DeviceDetailsById, httpStatus: number }>) => {
      return {
        isLoading: false,
        loadingError: null,
        customDeviceListByID: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    customDeviceByIdErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>) => {
      return {
        isLoading: false,
        loadingError: action.payload.errorMessage,
        customDeviceListByID: null,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

export const {
  customDeviceByIdLoadingAction,
  customDeviceByIdUpdateAction,
  customDeviceByIdErrorAction
} = customDeviceByIdSlice.actions

export default customDeviceByIdSlice.reducer
